import { AppLanguage } from './types';

type LoginDict = Record<string, string>;

const sr: LoginDict = {
  'login.welcome': 'Dobrodošli',
  'login.subtitle': 'Prijavite se korisničkim imenom',
  'login.language': 'Jezik',
  'login.username': 'Korisničko ime',
  'login.password': 'Lozinka',
  'login.usernamePlaceholder': 'Unesite korisničko ime',
  'login.passwordPlaceholder': 'Unesite lozinku',
  'login.submit': 'Prijavi se',
  'login.error': 'Greška pri prijavi'
};

const en: LoginDict = {
  'login.welcome': 'Welcome',
  'login.subtitle': 'Sign in with your username',
  'login.language': 'Language',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.usernamePlaceholder': 'Enter your username',
  'login.passwordPlaceholder': 'Enter your password',
  'login.submit': 'Sign in',
  'login.error': 'Sign-in failed'
};

const de: LoginDict = {
  'login.welcome': 'Willkommen',
  'login.subtitle': 'Melden Sie sich mit Ihrem Benutzernamen an',
  'login.language': 'Sprache',
  'login.username': 'Benutzername',
  'login.password': 'Passwort',
  'login.usernamePlaceholder': 'Benutzername eingeben',
  'login.passwordPlaceholder': 'Passwort eingeben',
  'login.submit': 'Anmelden',
  'login.error': 'Anmeldung fehlgeschlagen'
};

const pl: LoginDict = {
  'login.welcome': 'Witamy',
  'login.subtitle': 'Zaloguj się nazwą użytkownika',
  'login.language': 'Język',
  'login.username': 'Nazwa użytkownika',
  'login.password': 'Hasło',
  'login.usernamePlaceholder': 'Wprowadź nazwę użytkownika',
  'login.passwordPlaceholder': 'Wprowadź hasło',
  'login.submit': 'Zaloguj się',
  'login.error': 'Błąd logowania'
};

const cs: LoginDict = {
  'login.welcome': 'Vítejte',
  'login.subtitle': 'Přihlaste se uživatelským jménem',
  'login.language': 'Jazyk',
  'login.username': 'Uživatelské jméno',
  'login.password': 'Heslo',
  'login.usernamePlaceholder': 'Zadejte uživatelské jméno',
  'login.passwordPlaceholder': 'Zadejte heslo',
  'login.submit': 'Přihlásit se',
  'login.error': 'Chyba přihlášení'
};

const fr: LoginDict = {
  'login.welcome': 'Bienvenue',
  'login.subtitle': 'Connectez-vous avec votre nom d’utilisateur',
  'login.language': 'Langue',
  'login.username': 'Nom d’utilisateur',
  'login.password': 'Mot de passe',
  'login.usernamePlaceholder': 'Saisissez votre nom d’utilisateur',
  'login.passwordPlaceholder': 'Saisissez votre mot de passe',
  'login.submit': 'Se connecter',
  'login.error': 'Échec de la connexion'
};

const MESSAGES: Record<AppLanguage, LoginDict> = { sr, en, de, pl, cs, fr };

export const LOGIN_LANGUAGE_OPTIONS: {
  code: AppLanguage;
  label: string;
  short: string;
  emoji: string;
  flag?: string;
}[] = [
  { code: 'sr', label: 'Srpski', short: 'SR', emoji: '🇷🇸', flag: '/RS-flag.png' },
  { code: 'en', label: 'English', short: 'EN', emoji: '🇬🇧', flag: '/US-flag.png' },
  { code: 'de', label: 'Deutsch', short: 'DE', emoji: '🇩🇪', flag: '/GER-flag.png' },
  { code: 'pl', label: 'Polski', short: 'PL', emoji: '🇵🇱' },
  { code: 'cs', label: 'Čeština', short: 'CS', emoji: '🇨🇿' },
  { code: 'fr', label: 'Français', short: 'FR', emoji: '🇫🇷' }
];

export function translateLogin(lang: AppLanguage, key: string): string {
  return MESSAGES[lang]?.[key] || MESSAGES.en[key] || MESSAGES.sr[key] || key;
}
